export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.4.1-1636.43",
  commitId: "8e457565cfd06a6ddadd7aea3ecb15162e183573",
  commitTime: "2026-04-01T16:36:43.000Z",
});
